import { render, staticRenderFns } from "./TaskEventTable.vue?vue&type=template&id=16555651&"
import script from "./TaskEventTable.vue?vue&type=script&lang=js&"
export * from "./TaskEventTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports